import {Component, Input} from '@angular/core';
import {LoaderService, ToastService} from '@core/src/public-api';
import {AppointmentService} from '@shared/services/appointment.service';

@Component({
  selector: 'si-appo-appointment-proof',
  templateUrl: './appo-appointment-proof.component.html',
  styleUrls: ['./appo-appointment-proof.component.scss']
})
export class AppoAppointmentProofComponent {
  @Input() appointmentId: number;
  @Input() isButton: boolean;
  @Input() sendByEmail: boolean;

  constructor(
    private appointmentService: AppointmentService,
    private loaderService: LoaderService,
    private toastService: ToastService
  ) {
  }

  onClickProof(): void {
    this.sendByEmail ? this.sendProof() : this.downloadProof();
  }

  async downloadProof(): Promise<void> {
    this.loaderService.start();
    try {
      await this.appointmentService.getDownloadProof(this.appointmentId);
    } finally {
      this.loaderService.stop();
    }
  }

  async sendProof(): Promise<void> {
    this.loaderService.start();
    try {
      await this.appointmentService.getSendProof(this.appointmentId);
      this.toastService.success('SI_SEND_PROOF_EMAIL_SUCCESS');
    } finally {
      this.loaderService.stop();
    }
  }
}
